import { UtilityService } from '@app/services/utility/utility.service';
import { ContentModel } from '@app/models/content-data';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
})
export class ContentComponent {
    @Input() props: ContentModel = new ContentModel();

    constructor(public utilityService: UtilityService) {}
}
